import { BaseTable, Button, Card, Checkbox, HeaderMenu, PermissionLink } from "components";
import moment from "moment";
import { IoSendSharp } from "react-icons/io5";
import { convertNumber, useApi, useHandleAuth } from "utils";
import { FilterSection } from "./components";
import { useEffect, useState } from "react";
import { useDataAsset } from "./utils";
import toast from "react-hot-toast";
import { PERMISION } from "security";

type FilterType = {
    period_type: number,
    month: number,
    year: number,
    date: string
}


export default function Depreciation() {

    const api = useApi()
    const { userTokenData } = useHandleAuth()
    const userToken = userTokenData()

    const [fillter, setFillter] = useState<FilterType>({
        period_type: 1,
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        date: moment().format("YYYY-MM-DD")
    })

    const { data, refetch } = useDataAsset(fillter)
    const [isLoading, setIsLoading] = useState(false)
    const [selectedItems, setSelectedItems] = useState<number[]>([]);

    useEffect(() => {
        if (data && data.length > 0) {
            setSelectedItems(data.map(item => Number(item.asset_id)));
        }
    }, [data]);


    const handleCheckBox = (assetId: number) => {
        setSelectedItems((prevSelected) => {
            const isSelected = prevSelected.includes(assetId);
            const newSelected = isSelected
                ? prevSelected.filter(id => id !== assetId)
                : [...prevSelected, assetId];
            return newSelected;
        });
    };

    const total = data.filter(item => selectedItems.includes(item.asset_id)).reduce((prevValue, currentValue) => prevValue + Number(currentValue.dexpense), 0);

    const onSubmit = () => {
        const dataAfterSelect = data
            .filter((item) => selectedItems.includes(item.asset_id))
            .map(item => ({
                asset_id: item.asset_id,
                month: fillter.month,
                year: fillter.year,
                depreciation_expenses: item.dexpense,
                employee_id: userToken?.user_id,
                acquisition_cost: item.acquisition_cost,
                accumulated_depreciation: item.akum,
                asset_coa: item.coa_asset_id,
                depreciation_coa: item.coa_depreciation_id
            }))
        setIsLoading(true);
        return new Promise<void>((resolve) => {
            toast.promise(
                api.post(`/assetdepre/post_depreciation?transaction_date=${fillter.date}`, dataAfterSelect),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response?.data?.message ?? err.response?.message ?? "An error occurred"
                }
            )
                .then(() => {
                    setSelectedItems([])
                    refetch();
                })
                .catch(() => { })
                .finally(() => setIsLoading(false));
        });
    };

    return (
        <section className="container my-2">
            <HeaderMenu title="DEPRECIATION" />
            <section className="my-2">
                <Card>
                    <Card.Body>
                        <FilterSection
                            selected={fillter}
                            setSelected={setFillter}
                        />
                    </Card.Body>
                </Card>
            </section>
            <section>
                <Card>
                    <Card.Body>
                        <div className="overflow-x-scroll max-h-[calc(100vh-550px)]">
                            <BaseTable>
                                <thead className="!bg-black !text-white">
                                    <tr>
                                        <th rowSpan={2}>NO</th>
                                        <th rowSpan={2}>ASSET ID#</th>
                                        <th rowSpan={2}>DESCRIPTION</th>
                                        <th rowSpan={2}>GROUP</th>
                                        <th rowSpan={2}>BRAND</th>
                                        <th rowSpan={2}>ACQUISITION DATE</th>
                                        <th rowSpan={2}>ASSET AGE (YEAR)</th>
                                        <th rowSpan={2}>DUCUMENT TYPE</th>
                                        <th rowSpan={2}>SERIAL NUMBER</th>
                                        <th rowSpan={2}>ACQUISITION COST</th>
                                        <th rowSpan={2}>ACCUMULATED DEPRECIATION</th>
                                        <th rowSpan={2}>NET BOOK VALUE</th>
                                        <th colSpan={2}>ACCOUNT</th>
                                        <th rowSpan={2}>EXPENCES DEPRECIATION</th>
                                        <th rowSpan={2}>ACTION</th>
                                    </tr>
                                    <tr>
                                        <th>ASSET</th>
                                        <th>DEPRECIATION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.asset_code}</td>
                                            <td>{item.asset_name}</td>
                                            <td>{item.mr_group_name}</td>
                                            <td>{item.mr_brand_name}</td>
                                            <td>{moment(item.acquisition_date).format("DD/MM/YYYY")}</td>
                                            <td>{item.age}</td>
                                            <td>{item.mr_document_name}</td>
                                            <td>{item.serial_document}</td>
                                            <td className="text-right">{item.acquisition_cost ? convertNumber(Number(item.acquisition_cost)).intoCurrency : ""}</td>
                                            <td className="text-right">{item.akum ? convertNumber(Number(item.akum)).intoCurrency : ""}</td>
                                            <td className="text-right">{item.netbook ? convertNumber(Number(item.netbook)).intoCurrency : ""}</td>
                                            <td>{`${item.ca_code} - ${item.ca_name}`}</td>
                                            <td>{`${item.cd_code} - ${item.cd_name}`}</td>
                                            <td className="text-right">{item.dexpense ? convertNumber(Number(item.dexpense)).intoCurrency : ""}</td>
                                            <td className="flex items-center">
                                                <PermissionLink permission={PERMISION.ASET_MANAGEMENT.TRANSACTION.DEPRECIATION.UPDATE} to={`/asset-management/transaction/profile-asset/${item?.asset_id}`}>
                                                    <button
                                                        className="pe-4 rounded-full"
                                                        title="Collapse">
                                                        <IoSendSharp size={15} />
                                                    </button>
                                                </PermissionLink>
                                                {Number(item.dexpense) !== 0 &&
                                                    <Checkbox
                                                        onChange={() => handleCheckBox(item.asset_id)}
                                                        value={selectedItems.includes(item.asset_id)}
                                                    />
                                                }
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan={14} className="font-bold text-right text-md text-lg">
                                            TOTAL DEPRECIATION
                                        </th>
                                        <th className="text-right text-md font-bold text-lg">
                                            {total ? convertNumber(total).intoCurrency : 0}
                                        </th>
                                        <th>
                                            <Button
                                                type="button"
                                                color="primary"
                                                disabled={selectedItems.length === 0 || total === 0}
                                                onClick={() => onSubmit()}
                                                loading={isLoading ? "true" : undefined}
                                            >
                                                POST
                                            </Button>
                                        </th>
                                    </tr>
                                </tfoot>
                            </BaseTable>
                        </div>
                    </Card.Body>
                </Card>
            </section>
        </section>
    )
}